import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

const CONTACT_FORM_URL = 'https://readdy.ai/api/form/d96ddofpg5pqhofcunog';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黑料入口',
    description: '黑料入口是中文互联网领先的娱乐资讯聚合平台，致力于为用户提供最新、最全面的网红塌房、明星翻车、行业内幕等热门吃瓜内容。',
    url: 'https://www.heiliaorukou.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料入口',
      url: 'https://www.heiliaorukou.com',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://www.heiliaorukou.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 黑料入口 | 品牌介绍与联系方式"
        description="了解黑料入口的品牌故事、团队介绍与口碑评价。黑料入口是中文互联网领先的娱乐资讯聚合平台，致力于为用户提供最新最全的吃瓜内容。"
        keywords="黑料入口,关于黑料入口,黑料入口品牌介绍,黑料入口联系方式,吃瓜黑料入口"
        canonicalUrl="https://www.heiliaorukou.com/about"
        jsonLd={[aboutJsonLd, breadcrumbJsonLd]}
      />

      <div className="min-h-screen">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[{ label: '关于我们' }]}
            />

            <div className="mb-10">
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                关于黑料入口
              </h1>
              <p className="mt-2 text-foreground-500 text-sm max-w-2xl">
                吃瓜，就上黑料入口。我们致力于打造中文互联网最优质的娱乐资讯聚合平台。
              </p>
            </div>

            <BrandIntro />
            <Reputation />
            <ContactSection formUrl={CONTACT_FORM_URL} />

            <div className="py-10"></div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}